@import "../../../node_modules/highcharts/css/highcharts";

:host {
  /* Colors for data series and points */
  --highcharts-color-0: #2caffe;
  --highcharts-color-1: #544fc5;
  --highcharts-color-2: #00e272;
  --highcharts-color-3: #fe6a35;
  --highcharts-color-4: #6b8abc;
  --highcharts-color-5: #d568fb;
  --highcharts-color-6: #2ee0ca;
  --highcharts-color-7: #fa4b42;
  --highcharts-color-8: #feb56a;
  --highcharts-color-9: #91e8e1;

  /* Chart background, point stroke for markers and columns etc */
  --highcharts-background-color: transparent;

  /*
 Neutral colors, grayscale by default. The default colors are defined by
 mixing the background-color with neutral, with a weight corresponding to
 the number in the name.

 https://www.highcharts.com/samples/highcharts/css/palette-helper
 */

  /* Strong text. */
  --highcharts-neutral-color-100: currentColor;

  /* Main text, axis labels and some strokes. */
  --highcharts-neutral-color-80: currentColor;

  /* Axis title, connector fallback. */
  --highcharts-neutral-color-60: currentColor;

  /* Credits text, export menu stroke. */
  --highcharts-neutral-color-40: currentColor;

  /* Disabled texts, button strokes, crosshair etc. */
  --highcharts-neutral-color-20: currentColor;

  /* Grid lines etc. */
  --highcharts-neutral-color-10: color-mix(
    in srgb,
    currentColor 30%,
    transparent
  );

  /* Minor grid lines etc. */
  --highcharts-neutral-color-5: currentColor;

  /* Tooltip backgroud, button fills, map null points. */
  --highcharts-neutral-color-3: currentColor;

  /*
 Highlights, shades of blue by default
 */

  /* Drilldown clickable labels, color axis max color. */
  --highcharts-highlight-color-100: #0022ff;

  /* Selection marker, menu hover, button hover, chart border, navigator
 series. */
  --highcharts-highlight-color-80: #334eff;

  /* Navigator mask fill. */
  --highcharts-highlight-color-60: #667aff;

  /* Ticks and axis line. */
  --highcharts-highlight-color-20: #ccd3ff;

  /* Pressed button, color axis min color. */
  --highcharts-highlight-color-10: #e6e9ff;

  /* Indicators */
  --highcharts-positive-color: #06b535;
  --highcharts-negative-color: #f21313;
}

@media (prefers-color-scheme: dark) {
  :host {
    /* Highlight color variations */
    --highcharts-highlight-color-100: rgb(122, 167, 255);
    --highcharts-highlight-color-80: rgb(108, 144, 214);
    --highcharts-highlight-color-60: rgb(94, 121, 173);
    --highcharts-highlight-color-20: rgb(65, 74, 92);
    --highcharts-highlight-color-10: rgb(58, 63, 71);
  }
}

.chart-container {
  display: flex;
  width: 100%;
  height: 100%;
}

// Reset highcharts's default
.highcharts-container {
  font-family: inherit;
}
